/* eslint-disable @typescript-eslint/indent */

/* Note: please be careful with indentation, we have the rule disabled because of
*  eslint not being able to properly indent js inside styled components
*/

// Core
import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  width: 100%;
`;

export const SortContainer = styled.div`
  align-items: center;
  background-color: ${({ theme }) => theme.color.cardList.sortBackgroundColor};
  border-radius: 0.5rem;
  cursor: pointer;
  display: flex;
  gap: 6px;
  padding: 0.75rem 1rem;
`;

export const SortIconsContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const SortIcon = styled.div<{ isActive: boolean }>`
  display: flex;

  svg {
    width: 6px;
    height: 6px;
    color: ${({ theme, isActive }) => (
      isActive
        ? theme.color.cardList.sortIconActiveColor
        : theme.color.cardList.iconColor
    )};
  };
`;

export const CardContainer = styled.div`
  background-color: ${({ theme }) => theme.color.cardList.backgroundColor};
  border: 1px solid ${({ theme }) => theme.color.cardList.borderColor};
  border-radius: 8px;
  box-shadow:
    0px 4px 24px 0px ${({ theme }) => theme.color.cardList.cardShadowColor},
    0px 2px 6px 0px ${({ theme }) => theme.color.cardList.cardShadowColor};
  overflow: hidden;
  transition: all 0.2s ease-in-out;
`;

export const CardHeader = styled.div`
  align-items: center;
  cursor: pointer;
  display: flex;
  gap: 12px;
  padding: 0.75rem 1rem;

  &:hover {
    background-color: ${({ theme }) => theme.color.cardList.hoverBackgroundColor};
  };
`;

export const CardImageContainer = styled.div`
  flex-shrink: 0;
`;

export const CardTitleContainer = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
`;

export const CaretDownContainer = styled.div<{ isExpanded: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  transform: ${({ isExpanded }) => (isExpanded ? 'rotate(180deg)' : 'rotate(0deg)')};
  transition: transform 0.2s ease-in-out;

  svg {
    width: 20px;
    height: 20px;
    color: ${({ theme }) => theme.color.cardList.iconColor};
  };
`;

// Wrapper to enable smooth height animation using CSS Grid
export const CardContentWrapper = styled.div<{ isExpanded: boolean }>`
  display: grid;
  grid-template-rows: ${({ isExpanded }) => (isExpanded ? '1fr' : '0fr')};
  transition: grid-template-rows 0.25s ease-in-out;
`;

export const CardContentInner = styled.div`
  overflow: hidden;
`;

export const CardContent = styled.div`
  border-top: 1px solid ${({ theme }) => theme.color.cardList.contentBorderColor};
  padding: 1rem;
`;

export const CardDetails = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const CardButtonContainer = styled.div`
  margin-top: 0.5rem;
`;

export const EmptyState = styled.div`
  align-items: center;
  background-color: ${({ theme }) => theme.color.cardList.backgroundColor};
  border: 1px solid ${({ theme }) => theme.color.cardList.borderColor};
  border-radius: 8px;
  color: ${({ theme }) => theme.color.cardList.emptyStateIconColor};
  display: flex;
  flex-direction: column;
  gap: 8px;
  justify-content: center;
  padding: 2rem;

  svg {
    width: 40px;
    height: 40px;
  };
`;
